import { useEffect, useState } from 'react';

// Navigation bar colors
const NAV_DEFAULT_COLOR = '#f7f7f7'; // Nav bar when not scrolled
const NAV_SCROLLED_COLOR = '#ffffff'; // Nav bar when scrolled (white with shadow)

/**
 * Updates the theme-color meta tag to match the navigation bar.
 * When scrolled: white (nav bar has white background with shadow)
 * When not scrolled: default background (nav bar inherits from page)
 */
export const useThemeColor = () => {
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll events - matches NavigationBar logic
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    // Check initial scroll position on mount
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Update theme color when scroll state changes
  useEffect(() => {
    const themeColor = scrolled ? NAV_SCROLLED_COLOR : NAV_DEFAULT_COLOR;
    updateThemeColor(themeColor);
  }, [scrolled]);
};

/**
 * Updates the theme-color meta tag in the document head.
 * Creates the tag if it doesn't exist.
 */
function updateThemeColor(color) {
  let metaThemeColor = document.querySelector('meta[name="theme-color"]');
  
  if (!metaThemeColor) {
    metaThemeColor = document.createElement('meta');
    metaThemeColor.name = 'theme-color';
    document.head.appendChild(metaThemeColor);
  }
  
  metaThemeColor.setAttribute('content', color);
}

/**
 * Component version for use in Router context.
 * Use this in App.js alongside PageTracker.
 */
export const ThemeColorUpdater = () => {
  useThemeColor();
  return null;
};

export default useThemeColor;
